import { Outlet } from "react-router-dom";

/**
 * DefaultContentWrapper
 * Provides max-w-7xl centering for non-report protected pages.
 */
export function DefaultContentWrapper(): JSX.Element {
  return (
    <div className="h-full overflow-y-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
        <Outlet />
      </div>
    </div>
  );
}
